/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FavoriteToggleRequest } from '../models/FavoriteToggleRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FavoritesService {
    /**
     * Toggle a favorite application for the authenticated user
     * @param applicationId
     * @param requestBody
     * @param userSession
     * @returns void
     * @throws ApiError
     */
    public static toggleFavorite(
        applicationId: string,
        requestBody: FavoriteToggleRequest,
        userSession?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/favorites/{application_id}',
            path: {
                'application_id': applicationId,
            },
            cookies: {
                'user_session': userSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
